/**
 * Created by Ram on 12/05/2017.
 */

import React, { Component } from 'react';
import AnalyticsMenu from './Analytics/AnalyticsMenu';
import AnalyticsSummary from './Analytics/AnalyticsSummary';

class Analytics extends Component {
    render() {
        const { testInstance, scenario, triggersCount, isShowingSummary, showRemoteConfig } = this.props.loadData;
        const {
            callMapAnalytics,
            callMatrix,
            callBatteryStats,
            toggleShowSummary,
            displayRemoteConfigDetails,
        } = this.props;

        const menuButtons = [
            {
                name: 'Map Analytics',
                onClick: () => callMapAnalytics(testInstance._id),
                mode: 'Host-only',
            },
            {
                name: 'Matrix Analysis',
                onClick: () => callMatrix(testInstance._id),
                mode: 'Host-only',
            },
            {
                name: 'Battery Stats',
                onClick: () => callBatteryStats(testInstance._id),
                mode: 'Battery-only',
            },
        ];

        return (
            <div>
                <ol className="breadcrumb">
                    <li>
                        <a onClick={this.props.navigator.requestAnalyticsPagination}>Analytics</a>
                    </li>
                    <li className="active">Stats</li>
                </ol>

                <div className="analytics-main-div">
                    <div className="analytics-overview block">
                        <AnalyticsMenu buttons={menuButtons} testInstanceMode={testInstance.mode} />
                    </div>
                    <AnalyticsSummary
                        testInstance={testInstance}
                        scenario={scenario}
                        triggersCount={triggersCount}
                        isShowingSummary={isShowingSummary}
                        toggleSummary={toggleShowSummary}
                        showRemoteConfig={showRemoteConfig}
                        displayRemoteConfigDetails={displayRemoteConfigDetails}
                    />
                </div>

                {this.props.activeAnalytics}
            </div>
        ); // return
    } // render
} // Analytics

export default Analytics;
